






























































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import MonitoringGdsSvc from "@/services/MonitoringGdsService";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import { appModule } from "@/store/modules/app";
import moment from "moment";

@Component({
  components: {
    PersonAutoComplete
  }
})
export default class MonitoringGdsDetail extends Vue {
  @Prop() monitoringData!: any;
  @Prop() register!: string | number;
  @Prop() rm!: string;
  @Prop({ default: false }) readonly!: boolean;

  monitoring: any = null;
  saving = false;

  form: any = {
    register_id: "",
    pasien_rm: "",
    tanggal: moment().format("YYYY-MM-DD"),
    diagnosis: "",
    ket: "",
    perawat_user_id: null,
    dpjp_user_id: null
  };

  // Row dialog
  rowDialog = false;
  savingRow = false;
  rowForm: any = this.emptyRow();

  tindakanOptions = [
    { text: "RI (Insulin Reguler)", value: "RI" },
    { text: "D40% (Dextrose 40%)", value: "D40" }
  ];

  mounted() {
    if (this.monitoringData) {
      this.monitoring = this.monitoringData;
      this.populateForm();
    } else {
      this.form.register_id = this.register;
      this.form.pasien_rm = this.rm;
    }
  }

  get isLocked(): boolean {
    return this.readonly;
  }

  get gdsHint(): { label: string; color: string } | null {
    const v = Number(this.rowForm.gds_value);
    if (!v || isNaN(v)) return null;
    if (v < 55) return { label: "Hipoglikemia Berat", color: "red" };
    if (v < 70) return { label: "Hipoglikemia Ringan", color: "orange" };
    if (v <= 200) return { label: "Normal", color: "green" };
    if (v <= 300) return { label: "Hiperglikemia Ringan", color: "amber darken-2" };
    if (v <= 400) return { label: "Hiperglikemia Sedang", color: "deep-orange" };
    return { label: "Hiperglikemia Berat", color: "red darken-3" };
  }

  emptyRow() {
    return {
      id: null,
      tanggal: moment().format("YYYY-MM-DD"),
      jam: moment().format("HH:mm"),
      gds_value: null,
      tindakan: null,
      tindakan_dosis: "",
      keterangan: ""
    };
  }

  populateForm() {
    if (!this.monitoring) return;
    const m = this.monitoring;
    this.form = {
      register_id: m.register_id,
      pasien_rm: m.pasien_rm,
      unit_id: m.unit_id,
      tanggal: m.tanggal,
      diagnosis: m.diagnosis,
      ket: m.ket,
      perawat_user_id: m.perawat_user_id,
      dpjp_user_id: m.dpjp_user_id
    };
  }

  async simpan() {
    if (this.saving) return;
    this.saving = true;
    try {
      const resp = await MonitoringGdsSvc.create(this.form);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Lembar monitoring GDS dibuat");
        this.monitoring = resp.data.data;
        this.populateForm();
        this.$emit("saved");
      }
    } catch {
      // handled by service
    }
    this.saving = false;
  }

  async simpanUpdate() {
    if (this.saving) return;
    this.saving = true;
    try {
      const resp = await MonitoringGdsSvc.update(this.monitoring.id, this.form);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Header diperbarui");
        this.monitoring = resp.data.data;
        this.populateForm();
        this.$emit("saved");
      }
    } catch {
      // handled
    }
    this.saving = false;
  }

  openRowDialog(row?: any) {
    if (row) {
      this.rowForm = {
        id: row.id,
        tanggal: row.tanggal,
        jam: row.jam,
        gds_value: row.gds_value,
        tindakan: row.tindakan,
        tindakan_dosis: row.tindakan_dosis || "",
        keterangan: row.keterangan || ""
      };
    } else {
      this.rowForm = this.emptyRow();
    }
    this.rowDialog = true;
  }

  async simpanRow() {
    if (this.savingRow) return;
    if (!this.rowForm.tanggal || !this.rowForm.jam || !this.rowForm.gds_value) {
      appModule.NoticeDelay("Tanggal, Jam, dan GDS wajib diisi");
      return;
    }
    this.savingRow = true;
    try {
      const payload = {
        tanggal: this.rowForm.tanggal,
        jam: this.rowForm.jam,
        gds_value: this.rowForm.gds_value,
        tindakan: this.rowForm.tindakan || null,
        tindakan_dosis: this.rowForm.tindakan_dosis || null,
        keterangan: this.rowForm.keterangan || null
      };
      let resp;
      if (this.rowForm.id) {
        resp = await MonitoringGdsSvc.updateRow(this.monitoring.id, this.rowForm.id, payload);
      } else {
        resp = await MonitoringGdsSvc.addRow(this.monitoring.id, payload);
      }
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Baris tersimpan");
        this.rowDialog = false;
        await this.refreshData();
      }
    } catch {
      // handled
    }
    this.savingRow = false;
  }

  async hapusRow(row: any) {
    if (!confirm("Hapus baris ini?")) return;
    try {
      const resp = await MonitoringGdsSvc.deleteRow(this.monitoring.id, row.id);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Baris dihapus");
        await this.refreshData();
      }
    } catch {
      // handled
    }
  }

  async refreshData() {
    if (!this.monitoring?.id) return;
    try {
      const resp = await MonitoringGdsSvc.find(this.monitoring.id);
      if (resp?.data?.status == "1") {
        this.monitoring = resp.data.data;
        this.populateForm();
      }
    } catch {
      // handled
    }
    this.$emit("saved");
  }

  cetakPdf() {
    if (this.monitoring?.id) {
      MonitoringGdsSvc.printPdf(this.monitoring.id);
    }
  }

  formatDate(val: string) {
    if (!val) return "-";
    return moment(val).format("DD/MM/YYYY");
  }
}
